// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-btn--copy[data-v-205156f9]{display:inline-block;border:1px solid;border-radius:.25rem;background-color:#c7c7c7}.c-btn--copy[data-v-205156f9]:focus{outline:0}.c-btn--copy__inner-input[data-v-205156f9]{left:0;opacity:0;position:fixed;top:0}", ""]);
// Exports
module.exports = exports;
